<div class="widget" [ngClass]="{'loader-shown': loading, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-stage-counters" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element chart-loading"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons-outlined">pie_chart</span>
    </span>
    <span
      class="title"
      [pTooltip]="stageName + ' counters'"
      [tooltipDisabled]="stageName.length < 25"
      tooltipPosition="top"
    >
      {{ stageName }} counters
    </span>
    <button class="button-icon-round icon-w-fill icon-w-fill--transparent button-reload" (click)="reloadWidget()" pTooltip="Refresh" aria-label="Refresh widget data">
      <span class="icon material-icons-outlined" aria-hidden="true">refresh</span>
    </button>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">

    <div *ngIf="stageStarted" class="count-wrapper">
      <ng-container *ngIf="stageTypeName === 'Peer Review' || stageTypeName === 'Evaluation'">
        <div class="chart-wrapper chart-forms">
          <div class="doughnut-chart">
            <div class="doughnut-empty-state" pTooltip="No progress to display" *ngIf="!doughnutData3HasValue"></div>
            <p-chart #doughnutChart3 width="250px" height="250px" type="doughnut" [data]="doughnutData3" [options]="doughnutOptions" [plugins]="doughnutPlugins"></p-chart>
            <div class="total" [pTooltip]="totalTooltip3">
              <span>{{ total3 }}</span>
              <small>{{ totalWording3 }}</small>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="single-counters-wrapper" *ngIf="widgetSize > 50 && stageTypeName === 'Peer Review'">
        <div class="single-counter">
          <div class="count">{{ (stageData.participantsAssignedToPeerReview || stageData.participantsAssignedToPeerReview === 0) ? stageData.participantsAssignedToPeerReview : 'N/A' }}</div>
          <div class="title">Participants assigned to Peer Review</div>
        </div>
        <div class="single-counter">
          <div class="count">{{ (stageData.participantsCompletedTheirPeerReviews || stageData.participantsCompletedTheirPeerReviews === 0) ? stageData.participantsCompletedTheirPeerReviews : 'N/A' }}</div>
          <div class="title">Participants submitted their reviews</div>
        </div>
        <div class="single-counter">
          <div class="count">{{ (stageData.peerOptionalSubmitted || stageData.peerOptionalSubmitted === 0) ? stageData.peerOptionalSubmitted : 'N/A' }}</div>
          <div class="title">Optional Reviews Submitted</div>
        </div>
        <div class="single-counter">
          <div class="count">{{ (stageData.eliminatedDuringRedistribution || stageData.eliminatedDuringRedistribution === 0) ? stageData.eliminatedDuringRedistribution : 'N/A' }}</div>
          <div class="title">Eliminated during Redistribution</div>
        </div>
      </div>
      <div class="single-counters-wrapper" *ngIf="widgetSize > 50 && stageTypeName === 'Evaluation'">
        <div class="single-counter">
          <div class="count">{{ (stageData.participantsAssignedToEvaluationPanel || stageData.participantsAssignedToEvaluationPanel === 0) ? stageData.participantsAssignedToEvaluationPanel : 'N/A' }}</div>
          <div class="title">Participants assigned to EP</div>
        </div>
        <div class="single-counter">
          <div class="count">{{ (stageData.judgesAssignedToEvaluationPanel || stageData.judgesAssignedToEvaluationPanel === 0) ? stageData.judgesAssignedToEvaluationPanel : 'N/A' }}</div>
          <div class="title">Judges assigned to EP</div>
        </div>
        <div class="single-counter">
          <div class="count">{{ (stageData.judgesCompletedTheirReviews || stageData.judgesCompletedTheirReviews === 0) ? stageData.judgesCompletedTheirReviews : 'N/A' }}</div>
          <div class="title">Judges submitted their reviews</div>
        </div>
      </div>
      <div
        class="chart-wrapper chart-forms"
        *ngIf="stageTypeName === 'Registration Form' ||
                stageTypeName === 'Application Form' ||
                stageTypeName === 'Form' ||
                stageTypeName === 'Admin Review' ||
                stageTypeName === 'Bulk Review'"
      >
        <div class="doughnut-chart">
          <div class="doughnut-empty-state" pTooltip="No progress to display" *ngIf="!doughnutDataHasValue"></div>
          <p-chart #doughnutChart width="250px" height="250px" type="doughnut" [data]="doughnutData" [options]="doughnutOptions" [plugins]="doughnutPlugins"></p-chart>
          <div class="total" [pTooltip]="totalTooltip">
            <span>{{ total }}</span>
            <small>{{ totalWording }}</small>
          </div>
        </div>
      </div>
      <ng-container *ngIf="widgetSize > 50 && stageTypeName === 'Admin Review'">
        <div class="chart-wrapper chart-forms">
          <div class="doughnut-chart">
            <div class="doughnut-empty-state" pTooltip="No progress to display" *ngIf="!doughnutData2HasValue"></div>
            <p-chart #doughnutChart2 width="250px" height="250px" type="doughnut" [data]="doughnutData2" [options]="doughnutOptions" [plugins]="doughnutPlugins"></p-chart>
            <div class="total" [pTooltip]="totalTooltip2">
              <span>{{ total2 }}</span>
              <small>{{ totalWording2 }}</small>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    
    <div *ngIf="!stageStarted" class="custom-message">
      <span class="img-wrap"></span>
      <p>This stage is still locked.</p>
    </div>
  </div>
</div>